import type { IconName } from '../../svg-icons/iconsMap.ts'

export const BadgeDotType = {
	ONLINE: 'online',
	BUSY: 'busy',
	AWAY: 'away',
	OFFLINE: 'offline',
	NOTIFICATION: 'notification',
	IN_PROGRESS: 'inProgress'
} as const

export type BadgeDotType = (typeof BadgeDotType)[keyof typeof BadgeDotType]

export const BadgeDotSize = {
	SMALL: 'small',
	MEDIUM: 'medium',
	LARGE: 'large'
} as const

export type BadgeDotSize = (typeof BadgeDotSize)[keyof typeof BadgeDotSize]

export type BadgeDotConfig = {
	backgroundColor: string
	color: string
	icon?: IconName
}

export const BADGE_DOT_CONFIG: Record<BadgeDotType, BadgeDotConfig> = {
	[BadgeDotType.ONLINE]: {
		backgroundColor: '#067A57',
		color: '#FFFFFF',
		icon: 'checkmark'
	},
	[BadgeDotType.BUSY]: {
		backgroundColor: '#E4485B',
		color: '#FFFFFF',
		icon: 'close'
	},
	[BadgeDotType.AWAY]: {
		backgroundColor: '#FEC62E',
		color: '#5E4B00',
		icon: 'clock'
	},
	[BadgeDotType.OFFLINE]: {
		backgroundColor: '#003A661A',
		color: '#7C8D99',
		icon: 'close'
	},
	[BadgeDotType.IN_PROGRESS]: {
		backgroundColor: '#007ACC',
		color: '#FFFFFF',
		icon: 'refresh'
	},
	[BadgeDotType.NOTIFICATION]: {
		backgroundColor: '#E4485B',
		color: '#FFFFFF'
	}
}
